export default class ChatApiCalls {

  constructor(chatServerUrl, chatEventSource) {
    this.baseUri = `${chatServerUrl}/Api`;
    this.companyId = Monet.Session.Configurations.authConfigId;
    this.chatEventSource = chatEventSource;
  }

  enableAttendant = organizationList => {
    const attendantQueue = this._objectQueue(organizationList);
    this._postRequest('/AttendantQueue', attendantQueue)
  }

  disableAttendant = organizationList => {
    const objectDisable = this._objectQueue(organizationList);
    this._postRequest('/DisableAttendantQueue', objectDisable)
  }

  attendantQueues = (callback) => {
    this._getRequest(`/Attendants/${this._encodeIfIsUrl(this.companyId)}/${this.chatEventSource.getUserId()}`)
      .then(response => {
        const attendants = response.map(att => {
          return {
            id: att.organizationId
          }
        });
        if (callback) callback(attendants);
      });
  }

  _getRequest = uri => {
    const ajax = new Monet.Ajax({
      method: 'get',
      contentType: 'application/x-www-form-urlencoded',
      isSimpleRequest: true
    });
    ajax.url = `${this.baseUri}${uri}`;
    return ajax.send();
  }

  _postRequest = (uri, payload) => {
    const ajax = new Monet.Ajax({
      method: 'post',
      contentType: 'application/x-www-form-urlencoded',
      isSimpleRequest: true
    });
    ajax.url = `${this.baseUri}${uri}`;
    ajax.data = JSON.stringify(payload);
    return ajax.send();
  }

  _isUrl = uriFragment => (uriFragment.includes("http") || uriFragment.includes("greenmile.com"));

  _encodeIfIsUrl = pathFragment => {
    if (pathFragment) {
      return (this._isUrl(pathFragment.toString())) ? encodeURIComponent(pathFragment.toString()) : pathFragment.toString();
    } else {
      return pathFragment
    }
  }

  _objectQueue = (organizations) => {
    organizations = this._getListByValue(organizations);
    return {
      companyId: this.companyId.toString(),
      organizationIds: organizations,
      userId: this.chatEventSource.getUserId()
    };
  }

  _getListByValue = values => {
    if (!Array.isArray(values)) {
      values = function (value) {
        return [value]
      }(values);
    }
    return values;
  }
}
